export const FEATURE_NAME = '@zerops/zerops/feature/zcp-agent-auth-dialog';

// Timing — pause between agents in the multi-agent walker. Single-agent
// queues (len 1) use the same value as the "✓ authed, transitioning…" pause
// before either auto-closing (legacy single-agent) or showing the final
// "Go to Control Panel" CTA (multi-agent terminal state).
//
// Renamed from `AUTO_CLOSE_DELAY_MS` when the walker landed (Phase 2-b);
// the old 3000ms was sized for single-agent auto-close, the new 1000ms
// matches §6.4's "1s ✓ authed pause between agents."
export const AGENT_AUTH_PAUSE_MS = 1000;

/**
 * How long to wait for the terminal WebSocket to report `isConnected` after the
 * user clicks Start Authorization. Replaces a fixed 500ms magic delay that lost
 * the race on cold container starts. Reactive: completes on first `true`,
 * aborts with an error after the timeout window.
 */
export const TERMINAL_CONNECT_TIMEOUT_MS = 5000;

/**
 * Delay between Material's `afterOpened` event and mounting the terminal.
 * Gives xterm a stable container size to measure against — without this
 * margin the first render can have garbled glyphs.
 */
export const DIALOG_OPEN_TERMINAL_MOUNT_DELAY_MS = 150;

/**
 * Pause between unmounting the terminal and remounting it during a walker
 * advance (Claude finished → Codex starts). Lets Angular fully tear down
 * the previous z-terminal instance + close its WebSocket so the next agent
 * gets a clean shell session instead of inheriting the previous agent's
 * scrollback. Same 150ms as the initial mount — long enough for cleanup,
 * short enough that the empty pane isn't visually noticeable.
 */
export const TERMINAL_REMOUNT_DELAY_MS = 150;

/** Outlasts the dialog close animation so `#resetState()` doesn't fight a still-visible component. */
export const DIALOG_CLOSE_RESET_DELAY_MS = 300;

/** How long the "Copied!" feedback stays on screen after the user copies the auth URL. */
export const COPY_FEEDBACK_DURATION_MS = 2000;

/**
 * Gap between sending the pasted auth code and the trailing CR. Some terminal
 * pipelines drop the newline if it lands in the same chunk as the code.
 */
export const SEND_CODE_NEWLINE_DELAY_MS = 100;

/**
 * Default delay between items when a `postAuthScreens` entry uses the array
 * form for sequenced key sends (Tab Tab Enter, etc.). Ink/Bubble-Tea TUIs
 * need a render frame between widget-focus changes; bursting everything in
 * one write lands the final Enter on stale focus state. 100ms empirically
 * leaves enough headroom across local + remote PTYs.
 */
export const POST_AUTH_KEY_DELAY_MS = 100;
